/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILanguage } from 'app/shared/model/language.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { Fluency } from 'app/shared/model/enumerations/fluency.model';

export interface IDoctorLanguage {
  id?: string;
  fluency?: keyof typeof Fluency;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  language?: ILanguage;
  doctor?: IDoctor;
}

export const defaultValue: Readonly<IDoctorLanguage> = {
  active: false,
};
